import * as React from "react";
import {
  DefaultNodeModel,
  DefaultPortLabel,
  DiagramEngine,
  BaseWidget,
  BaseWidgetProps
} from "storm-react-diagrams";

export interface DefaultNodeProps extends BaseWidgetProps {
  node: DefaultNodeModel;
  diagramEngine: DiagramEngine;
}

export interface DefaultNodeState {
  showAll: boolean;
}

/**
 * See https://github.com/projectstorm/react-diagrams/blob/master/src/defaults/widgets/DefaultNodeWidget.tsx
 */
export class CustomNodeWidget extends BaseWidget<
  DefaultNodeProps,
  DefaultNodeState
> {
  constructor(props: DefaultNodeProps) {
    super("srd-default-node", props);
    this.state = {
      showAll: false
    };
  }

  generatePort(port: any) {
    return <DefaultPortLabel model={port} key={port.id} />;
  }

  render() {
    const message = this.props.node.extras.q || "";
    const { showAll } = this.state;
    let shortMessage = message;
    const hasLongMessage = message.length > 50;
    if (hasLongMessage) {
      shortMessage = message.slice(0, 50) + "...";
    }
    return (
      <div {...this.getProps()} style={{ background: this.props.node.color }}>
        <div className={this.bem("__ports")}>
          <div className={this.bem("__in")}>
            {this.props.node.getInPorts().map(this.generatePort.bind(this))}
          </div>
        </div>
        <div className={this.bem("__title")}>
          <div className={this.bem("__name")}>{this.props.node.name}</div>
        </div>
        <div className={this.bem("__message")}>
          <span
            dangerouslySetInnerHTML={{
              __html: showAll ? message : shortMessage
            }}
          />
          {hasLongMessage && (
            <em className="message-toggler" onClick={() => this.toggle()}>
              ({!showAll ? "more" : "less"})
            </em>
          )}
        </div>
        <div className={this.bem("__ports")}>
          <div className={this.bem("__out")}>
            {this.props.node.getOutPorts().map(this.generatePort.bind(this))}
          </div>
        </div>
      </div>
    );
  }
  private toggle() {
    this.setState({
      showAll: !this.state.showAll
    });
  }
}



// WEBPACK FOOTER //
// ./src/designer/widgets/CustomNodeWidget.tsx